'use client';

import { useMemo } from 'react';

import { useAttGöra } from 'src/sections/att-gora/use-att-gora';
import { useKomIgång } from 'src/sections/kom-igang/use-kom-igang';

import { ärNystartad, härledVälkomstläge } from './valkomstlage';

import type { Välkomstläge, Tidslinjepost } from './valkomstlage';

// ----------------------------------------------------------------------

/**
 * Välkomstbannerns läge för den valda föreningen.
 *
 * Hubben använder inte den här: den har redan alla föreningars poster samlade och anropar
 * `härledVälkomstläge` direkt.
 */
export function useVälkomstläge(): { läge: Välkomstläge; idag: ReturnType<typeof useAttGöra>['idag'] } {
  const { öppna, idag } = useAttGöra();
  const { status, laddar } = useKomIgång();

  const läge = useMemo(() => {
    const poster: Tidslinjepost[] = öppna.map((post) => ({
      id: post.id,
      titel: post.titel,
      förfallodag: post.förfallodag,
      länk: post.länk,
      internLänk: post.internLänk,
    }));
    // Myndighetsdatumen räknas ut lokalt och finns direkt; det som laddas är kom igång-statusen,
    // som avgör om föreningen ska mötas av förstagångsläget.
    return härledVälkomstläge({ laddar, poster, idag, nystartad: ärNystartad(status) });
  }, [öppna, idag, status, laddar]);

  return { läge, idag };
}
